module.exports = __webpack_public_path__ + "img/wb.c01c024c.png";